
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IoTsErrorNotification } from "@/types/notifications";
import Icon from "@/components/UI/Icon.vue";
@Component({
  components: { Icon }
})
export default class IoTsError extends Vue {
  @Prop()
  value!: IoTsErrorNotification;
}
